var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { elevation: "0" } },
    [
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0" },
        [
          _c("c-master-table", {
            on: {
              "show-configs-popup-edit-info": _vm.showEditInfoPopup,
              "show-c-edit-tag-popup": _vm.showEditTagPopup,
              "show-c-p-r-deploy-with-merge-popup":
                _vm.showDeployWithMergePopup,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }